import React from 'react';

var ContentLoader = function (_a) {
    var logoSrc = _a.logoSrc, isFull = _a.isFull;
    return (React.createElement("div", { className: "content-loader ".concat(isFull ? 'is-full' : '') },
        React.createElement("img", { src: logoSrc, alt: 'content-logo' })));
};

export { ContentLoader };
